module.exports = __webpack_public_path__ + "img/christmas-window-1.74561dcd.svg";